/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiConfiguration } from '../api-configuration';
import { BaseService } from '../base-service';
import { transfer, Transfer$Params } from '../fn/transfer/transfer';
import { Transfer } from '../models/transfer';
import { StrictHttpResponse } from '../strict-http-response';

/**
 * Transfer vehicle configurations
 */
@Injectable({ providedIn: 'root' })
export class TransferService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `transfer()` */
  static readonly TransferPath =
    '/api/v3/{market}/{subProcess}/{dataVersion}/vehicles/{vehicleId}/transfer/{baumusterNst}';

  /**
   * Transfer vehicle-configuration to a initial configuration based on BaumusterNST.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transfer()` instead.
   *
   * This method doesn't expect any request body.
   */
  transfer$Response(params: Transfer$Params, context?: HttpContext): Observable<StrictHttpResponse<Transfer>> {
    return transfer(this.http, this.rootUrl, params, context);
  }

  /**
   * Transfer vehicle-configuration to a initial configuration based on BaumusterNST.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `transfer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  transfer(params: Transfer$Params, context?: HttpContext): Observable<Transfer> {
    return this.transfer$Response(params, context).pipe(map((r: StrictHttpResponse<Transfer>): Transfer => r.body));
  }
}
